import {MoreMenu} from '../ui/Mobile';
import { useEffect } from "react";
import { useLiveQuery } from "dexie-react-hooks";
import { useService } from "./context";
import { Outlet, useLocation, useRouteError } from "react-router-dom";
import { Link } from "./navigation";
import { ModuleNavigation, NavigationContext, ContextBack, moduleFor } from "./navigation";
import { Icon } from "../ui/Icons";
import { useOffline } from "./offline";

export function AppShell() {
  const location = useLocation();
  const offline = useOffline();
  const { db } = useService();
  const writeState = useLiveQuery(() => db.meta.get("writeState"), [db]);
  const editing =
    location.pathname.startsWith("/sop/runs/") ||
    location.pathname === "/capture/new" ||
    location.pathname.endsWith("/edit") ||
    location.pathname.endsWith("/new");
  useEffect(()=>{const nav=document.querySelector('.module-nav');if(!nav){document.documentElement.style.setProperty('--nav-height','0px');return;}const resize=new ResizeObserver(()=>document.documentElement.style.setProperty('--nav-height',nav.getBoundingClientRect().height+'px'));resize.observe(nav);return()=>resize.disconnect();},[editing]);

  return (
    <>
      <a className="skip-link" href="#main">
        跳到主要内容
      </a>
      {!editing && (
        <header className="app-header">
          <Link className="brand" to="/home" aria-label="Nook 首页">
            <span className="brand-word">nook.</span>
          </Link>
          <nav aria-label="当前可用工具">
            <Link to="/search" className="icon-button" aria-label="搜索"><Icon name="search" /></Link>
            <MoreMenu entries={[
              ...(location.pathname.startsWith('/sop')?[{to:'/sop/history',label:'执行历史'},{to:'/sop/manage',label:'SOP 管理'}]:[]),
              ...(location.pathname==='/space'?[{to:'/space/manage',label:'空间管理'}]:[]),
              {to:'/settings/data',label:'本机与离线'},{to:'/settings/backup',label:'备份与恢复'},{to:'/trash',label:'回收站'}
            ]}/>
            <Link
              to="/capture/new?view=sheet"
              state={{ from: location.pathname+location.search }}
              className="icon-button capture-tool" aria-label="记一下"
            >
              <Icon name="plus" />
              <span className="sr-only">记一下</span>
            </Link>
          </nav>
        </header>
      )}
      {!offline.online && (
        <div className="offline-banner" role="status">
          离线，可继续记录。
        </div>
      )}
      {writeState && writeState.value !== "active" && (
        <div className="notice" role="status">
          数据正在维护或本页已属于旧版本。输入仍可保留，暂不能存下。
          <Link to="/settings/backup">查看数据操作</Link>
        </div>
      )}
      <NavigationContext/>
      <Outlet />
      {!editing && <ModuleNavigation/>}

    </>
  );
}

export function RouteError() {
  const error = useRouteError();
  return (
    <><main className="page" id="main">
      <p className="eyebrow">Nook · 本机记录</p><h1>页面暂时没有打开</h1>
      <p>本机数据未被清空。请返回收件箱，或重新打开应用。</p>
      <details className="diagnostics"><summary>查看错误详情</summary><p className="small-note">
        {error instanceof Error ? error.message : "页面读取错误"}
      </p></details>
      <a className="button primary" href="/inbox">
        返回收件箱
      </a>
    </main><ModuleNavigation/></>
  );
}

export function MissingPage(){const location=useLocation();return <main className="page secondary-page" id="main" data-ready="true"><h1>这个页面不存在</h1><p>这个地址无法打开。可以返回原位置，或从所属模块继续查找。</p><ContextBack fallback={moduleFor(location.pathname)}>返回原位置</ContextBack><Link className="button secondary" to={moduleFor(location.pathname)}>打开所属模块</Link></main>;}
